import React from 'react';
import './EducationPartners.css';

function EducationPartners() {
  const awards = [
    'IMG1copy.webp',
    'IMG2copy.webp',
    'IMG3copy.webp',
    'IMG4copy.webp',
    'IMG5copy.webp',
    'IMG6copy.webp',
    'IMG7copy.webp',
    'IMG8copy.webp',
    'IMG9copy.webp',
    'IMG10copy.webp',
    'IMG11copy.webp',
    'IMG12copy.webp',
    'IMG13copy.webp',
    'IMG14copy.webp',
    'IMG15copy.webp',
    'IMG16copy.webp',
    'IMG17copy.webp',
    'IMG18copy.webp',
    'IMG19copy.webp',
    'IMG20copy.webp',
    'IMG21copy.webp',
    'IMG22copy.webp',
    'IMG23copy.webp',
    'IMG24copy.webp',
    'IMG25copy.webp'
  ];

  return (
    <div className="edu-circle-logos">
      <div className="rs5865f2-titleWrap">
        <div className="rs5865f2-titleRow">
          <div className="rs5865f2-titlePlain">Awards & </div>
          <div className="rs5865f2-titleGradient">Recognition</div>
        </div>
        <div className="rs5865f2-gradientLine" />
      </div>

      <div className="carousel-track-container">
        <div className="carousel-track">
          {/* First original set */}
          <div className="carousel-group">
            {awards.map((logo, i) => (
              <div className="award-card" key={`original-${i}`}>
                <img 
                  src={encodeURI(`/Awards/${logo}`)} 
                  alt={`Award ${i + 1}`} 
                  loading="lazy" 
                />
              </div>
            ))}
          </div>
          
          {/* Duplicated set for seamless infinite scrolling */}
          <div className="carousel-group" aria-hidden="true">
            {awards.map((logo, i) => (
              <div className="award-card" key={`duplicate-${i}`}>
                <img 
                  src={encodeURI(`/Awards/${logo}`)} 
                  alt={`Award duplicate ${i + 1}`} 
                  loading="lazy" 
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EducationPartners;